import { Breadcrumb } from "@refinedev/mui";
import { Box } from "@mui/material";
import PageHeading from "../../components/pageHeading";
export const CYRCLibraryReadAloudSessionsConducted = () => {
  return (
    <Box>
      <Breadcrumb />
      <PageHeading heading="Read-aloud sessions conducted" />
    </Box>
  );
};
